// extracted by mini-css-extract-plugin
export default {"params":"style_params__kJO1o","customInput":"style_customInput__rdybS"};